<div class="row  mt-1">
    <div class="offset-sm-10 col-sm-2">
        <div class="form-group">
            <h6>&nbsp;</h6>
            <button class="form-control form-control-sm btn-light shadow-sm btn-st float-right"
                (click)="RaisePermissionModal(content_permission, false, true)">
                <i aria-hidden="true" class="fa fa-plus cursor-hand"></i> Agregar Rol</button>
        </div>

    </div>
</div>
<div class="row" cdkDropListGroup>
    <div class="col-sm-3 mt-2">
        <h5>Roles</h5>
        <ul class="list-group list-group mt-1 min-role-size">
            <li [ngClass]="{'selectedRole' : role.IsSelected}" class="list-group-item item-hover" *ngFor="let role of roles" [id]="role.Id" (click)="SelectRole(role)"> <i class="fa fa-edit" style="cursor: pointer; font-size: 15px;" title="Editar rol" (click)="GetRole(role.Id, content_permission)"></i> {{role.Name}} <i *ngIf="!role.IsActive" ngbPopover="Role inactivo" triggers="mouseenter:mouseleave"
                    class="fa fa-circle" style="font-size: 10px; margin-bottom: 15px; color: rgba(255, 0, 0, 0.5);;" aria-hidden="true"></i></li>
        </ul>
    </div>
    
    <div class="col-sm-4 mt-2">
        <h5>Permisos asociados</h5>
        <div cdkDropList [cdkDropListData]="Assignedpermissions" class="example-list"
            (cdkDropListDropped)="drop($event)">
            <div class="example-box item-hover" *ngFor="let item of Assignedpermissions" cdkDrag>
                {{item.Name}}</div>
        </div>
    </div>
    
    <div class="col-sm-1 mt-2">
        <h6>&nbsp;</h6>
        <button class="btn btn-sm btn-light btn-st shadow btn-block" (click)="OffsetPermissions(0)"><i
                class="fa fa-arrow-right" aria-hidden="true"></i></button>
        <br>
        <button class="btn btn-sm btn-light btn-st shadow btn-block" (click)="OffsetPermissions(1)"><i
                class="fa fa-arrow-left" aria-hidden="true"></i></button>
    </div>
    <div class="col-sm-4 mt-2">
        <h5>Permisos disponibles</h5>

        <div cdkDropList [cdkDropListData]="permissions" class="example-list"
            (cdkDropListDropped)="drop($event)">
            <div class="example-box item-hover" *ngFor="let item of permissions" cdkDrag>{{item.Name}}
            </div>
        </div>
    </div>
</div>
<!-- Ventana modal-->
<ng-template #content_permission let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ isPermissionNavActive ? 'Permiso': 'Rol' }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
       
        <form [formGroup]="roleForm">
            <div class="form-group" style="display: none;">
                <label for="">Id</label>
                <input type="number" class="form-control form-control-sm" aria-describedby="" formControlName="Id">
            </div>
            <div class="form-group mRequired">
                <label for="">Nombre</label>
                <input *ngIf="roleForm.get('Id').value == -1" type="text" class="form-control form-control-sm"
                    aria-describedby="" formControlName="Name">
                <input *ngIf="roleForm.get('Id').value != -1" type="text" class="form-control form-control-sm"
                    readonly aria-describedby="" formControlName="Name">
            </div>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" formControlName="IsActive"
                    style="transform: scale(1.5);">
                <label class="form-check-label" for="exampleCheck1">Activo</label>
            </div>
        </form>
        <br>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">

                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right"
                    (click)="Store()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st"
                    (click)="ClosePermissionModal()"><i class="fa fa-times-circle" aria-hidden="true"></i>
                    Cerrar&nbsp;</button>

            </div>
        </div>
    </div>
</ng-template>